import { render, staticRenderFns } from "./MedicalEDM.vue?vue&type=template&id=019d7524&scoped=true"
import script from "./MedicalEDM.vue?vue&type=script&lang=js"
export * from "./MedicalEDM.vue?vue&type=script&lang=js"
import style0 from "./MedicalEDM.vue?vue&type=style&index=0&id=019d7524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d7524",
  null
  
)

export default component.exports